import { Defaults } from 'es-decorators'
import { View } from 'es6/components/view'

@Defaults({
  el: '.sl-description',
  events: {
    'click .sl-description-control': 'toggleText',
    'click:not .sl-description-control': 'preventToggle',
    'touch:not .sl-description-control': 'preventToggle',
  },
  maxHeight: 420,
  paddingBottom: 50,
  showButtonText: 'Подробнее',
  hideButtonText: 'Свернуть',
})

export class SeoTextView extends View {
  /**
   * @inheritDoc
   */
  run () {
    this.$descriptionText = this.$('.sl-description-text')
    this.$controlButton = this.$('.sl-description-control')
    this.$seoTextElement = $('.seo-text-category')
    this.$window = $(window)
    this.windowWidth = window.innerWidth
    this.$window.on('resize', this.toggleTextOnResize.bind(this))
    setTimeout(this.makeTextVisible.bind(this), 750)
  }

  /**
   * Задерживаем появление текста, чтобы не мелькал вверху экрана при загрузке страницы.
   */
  makeTextVisible () {
    this.$descriptionText.css({
      'visibility': 'visible',
    })
    if (this.$descriptionText.html() === '') {
      this.$controlButton.hide()
    }
    // если описание товара всего ненамного длиннее максимального размера то нет смысла его скрывать
    if (this.$descriptionText.height() <= this.maxHeight + this.paddingBottom) {
      this.showText()
      this.$controlButton.hide()
    } else {
      this.hideText()
    }
    this.setHeightToSeoTextElement()
  }

  /**
   * Показывает текст.
   */
  showText () {
    this.$descriptionText.css({
      'max-height': 'none',
      'padding-bottom': this.paddingBottom,
    })
    this.$controlButton.html(this.hideButtonText)
  }

  /**
   * Сворачивает/разворачивает текст после ресайза окна.
   */
  toggleTextOnResize () {
    if (this.windowWidth !== window.innerWidth) {
      if (this.$descriptionText.height() >= this.maxHeight) {
        this.$controlButton.show()
        this.hideText()
      } else {
        this.$controlButton.hide()
        this.showText()
      }
      this.setHeightToSeoTextElement()
      this.windowWidth = window.innerWidth
    }
  }

  /**
   * Сворачивает текст.
   */
  hideText () {
    this.$descriptionText.css({
      'max-height': this.maxHeight,
      'padding-bottom': 0,
    })
    this.$controlButton.html(this.showButtonText)
  }

  /**
   * Сворачивает/разворачивает текст.
   */
  toggleText () {
    if (this.$descriptionText.css('max-height') === `${this.maxHeight}px`) {
      this.showText()
    } else {
      this.hideText()
    }
    this.setHeightToSeoTextElement()
  }

  /**
   * Устанавливает высоту вспомогательному блоку.
   */
  setHeightToSeoTextElement () {
    this.$seoTextElement.height(this.$descriptionText.outerHeight())
  }

  /**
   * На iOS предотвращает bubble события клика на контейнере к контролу.
   * @param {Event} e событие клика.
   */
  preventToggle (e) {
    e.preventDefault()
    e.stopPropagation()
  }
}
